import React, { Component } from 'react';

export default class ReadingProgress extends Component {
  state = {
    progress: 0
  }

  componentDidMount = () => window.addEventListener('scroll', this.handleScroll);

  componentWillUnmount = () => window.removeEventListener('scroll', this.handleScroll);

  handleScroll = () => {
    let h = document.documentElement;
    let b = document.body;
    let st = 'scrollTop';
    let sh = 'scrollHeight';
    let percent = (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100;

    this.setState({ progress: percent });
  }

  render() {
    if (!this.state.progress) return <></>;

    return (
      <div className="progress">
        <div className="progress__bar" style={{ width: `${this.state.progress}%` }}></div>
      </div>
    )
  }
}
